import type { NextLink, Operation } from '@apollo/client';
import { ApolloLink } from '@apollo/client';

import { getTokenFromLocalStorage } from 'common/helpers/jwtHelper';

export function getAuthToken(): string {
  const token = getTokenFromLocalStorage();
  return token ? `Bearer ${token}` : '';
}

export default new ApolloLink((operation: Operation, forward: NextLink) => {
  // Add the token to the request headers.
  operation.setContext(({ headers = {} }: { headers: Headers | Record<string, unknown> }) => ({
    headers: {
      ...headers,
      authorization: getAuthToken(),
    },
  }));

  return forward(operation);
});
